module.exports = __webpack_public_path__ + "static/media/ic_no_order.5e25fe99.png";